export class SchedulerTaskPrintConfiguration {
  constructor(
    public hash?: string,
    public originHash?: string,
    public printHash?: string,
    public printReference?: string,
    public userReference?: number,
    public x?: number,
    public y?: number,
    public z?: number,
    public c?: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-print-configuration.ts